// Definición de defaults

export const defaultNacionalidad: NacionalidadProps = {
    idNacionalidad:     0,
    descripcion:        '',
    activo:             false,
}

// Creación de interfaces

export interface NacionalidadProps {
    idNacionalidad:        number;
    descripcion:             string;
    activo:                  boolean;
}